// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__JK0vz","selectRate":"Select_selectRate__Oh1nx"};